import { gql } from "@apollo/client";

export const QUERY_FP_ANALYSIS_DATA = gql`
  query getFPAnalysisData {
    getFPAnalysisData {
      driverRuns {
        driver
        runs {
          lapNumber
          startTime
          duration
          predictedLapTime
          type
          highPower
          powerModeFastestSoFarPush
          powerModeFastestSoFarAll
          valid
          loopSectors {
            loop
            time
          }
          tyreData {
            frontLeft
            frontRight
            rearLeft
            rearRight
            sided
            set
          }
        }
      }
      isFullWetSession
      highlightWetPeriod
      wetPeriodRange
    }
  }
`;

export const SUBSCRIBE_FP_ANALYSIS_DATA = gql`
  subscription newFPAnalysisUpdate {
    newFPAnalysisUpdate {
      reset
      driverRuns {
        driver
        runs {
          lapNumber
          startTime
          duration
          predictedLapTime
          type
          highPower
          powerModeFastestSoFarPush
          powerModeFastestSoFarAll
          valid
          loopSectors {
            loop
            time
          }
          tyreData {
            frontLeft
            frontRight
            rearLeft
            rearRight
            sided
            set
          }
        }
      }
      isFullWetSession
      highlightWetPeriod
      wetPeriodRange
    }
  }
`;

export const MUTATE_SET_FULL_WET_SESSION = gql`
  mutation setFullWetSession($isFullWetSession: Boolean!) {
    setFullWetSession(isFullWetSession: $isFullWetSession)
  }
`;

export const MUTATE_SET_WET_PERIOD = gql`
  mutation setWetPeriod(
    $highlightWetPeriod: Boolean!
    $wetPeriodRange: [Float!]!
  ) {
    setWetPeriod(
      highlightWetPeriod: $highlightWetPeriod
      wetPeriodRange: $wetPeriodRange
    )
  }
`;
